import { CrossPlatformCompressorJS } from './cross-platform-compressor';

/**
 * Returns the current URL with compressed search parameters.
 * @returns The compressed URL.
 */
export function getCompressedUrl() {
  if (typeof window === 'undefined') return '';

  const urlWithoutSearch = `${window.location.origin}${window.location.pathname}`;
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.size === 0) return urlWithoutSearch;

  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const compressedParams = CrossPlatformCompressorJS.encode(params);
  const newUrl = `${urlWithoutSearch}?trk=${compressedParams}`;

  return newUrl;
}
